import { stringExtensions } from "@architecture-innovation-transformation/lib-common";
import { Divider, Icons, Show, Tabs, Tag } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { OrgChart } from "components/common/orgChart";
import { DisplayBasicProfile } from "components/profile/displayBasicProfile";
import { DisplayDetailedProfile } from "components/profile/displayDetailedProfile";
import { DisplayRnRTab } from "components/profile/displayRnRTab";
import { ObjectMetadata } from "components/utils/objectMetadata";
import { IBaseProps, IUser } from "interfaces";
import { DATAPROVIDER_READ } from "scripts/site";

export const PeopleShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IUser>({
    dataProviderName: DATAPROVIDER_READ
  });
  const { data, isLoading } = queryResult;
  const record = data?.data as IUser;

  const getTabs = () => {
    let tabs: any[] = [];
    // Render tabs, if record exists
    if (record) {
      // Add the Info Tab
      tabs.push(
        {
          label: (<span><Icons.IdcardOutlined />Info</span>),
          key: "info",
          children: <>
            {<DisplayBasicProfile {...record}></DisplayBasicProfile>}
            {<DisplayDetailedProfile {...record}></DisplayDetailedProfile>}
          </>
        });

      // For Employees
      if (record.employee) {
        //Add R&R Tabs
        tabs.push({
          label: (<span><Icons.StarOutlined />Rewards and Recognition</span>),
          key: "randr",
          children: <>
            {<DisplayRnRTab {...record.employee}></DisplayRnRTab>}
          </>
        });

        // Organization Chart
        tabs.push({
          label: (<span><Icons.ApartmentOutlined />True Hierarchy&trade;</span>),
          key: "orgchart",
          children: <OrgChart {...record}></OrgChart>
        });
      }
    }
    return tabs;
  }

  return (
    <Show isLoading={isLoading}
      title={record?.name}
      headerProps={{
        tags: record?.stateManager?.state ? <Tag>{stringExtensions.capitalize(record?.stateManager?.state)}</Tag> : <></>,
      }}
      headerButtons={<></>}
    >
      <Tabs
        items={getTabs()}
      />
      <Divider></Divider>
      <div style={{ marginTop: 15 }}>
        <ObjectMetadata {...record as IBaseProps} ></ObjectMetadata>
      </div>
    </Show>
  );
};
